import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PageHeader from "@/components/PageHeader";

/**
 * Branded 404. On mount we set:
 *   - <meta name="robots" content="noindex">
 *   - <meta name="prerender-status-code" content="404">
 * so Emergent's crawler-cache serves the prerender with a real 404 and
 * search engines do not index the page.
 */
export default function NotFound() {
    useEffect(() => {
        const setMeta = (name, content) => {
            let el = document.head.querySelector(`meta[name="${name}"]`);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute("name", name);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
            return el;
        };
        const robotsEl = setMeta("robots", "noindex");
        const statusEl = setMeta("prerender-status-code", "404");
        document.title = "Page not found | Moving Mountains Advisors";
        if (typeof window !== "undefined") {
            // Signal to the crawler that this page is ready to be snapshotted.
            window.prerenderReady = true;
        }
        return () => {
            // On unmount restore the robots meta so SPA navigations away from
            // 404 aren't accidentally kept noindex.
            if (robotsEl && robotsEl.parentNode) robotsEl.parentNode.removeChild(robotsEl);
            if (statusEl && statusEl.parentNode) statusEl.parentNode.removeChild(statusEl);
        };
    }, []);

    return (
        <div data-testid="not-found-page">
            <PageHeader
                eyebrow="404"
                title="That page moved mountains."
                subtitle="The link you followed might be outdated or the page has been retired."
            >
                <div className="flex flex-wrap items-center justify-center gap-2">
                    <Link to="/" className="mm-btn-primary" data-testid="not-found-home">
                        Go home
                    </Link>
                    <Link to="/blog" className="mm-btn-outline" data-testid="not-found-blog">
                        Browse the blog
                    </Link>
                    <Link to="/jarvis" className="mm-btn-outline" data-testid="not-found-jarvis">
                        Talk to Jarvis
                    </Link>
                </div>
            </PageHeader>
        </div>
    );
}
